import React, { useState, useEffect } from 'react';

import { collection, query, orderBy, limit, getDocs, startAfter, startAt,  getDoc, arrayUnion, onSnapshot, doc, updateDoc } from 'firebase/firestore';
import { useNotifications } from "../../../utils/NotificationContext/NotificationContext";
import DebaterAssignCache from '../../DebaterAssign/DebaterAssignCache';
import ModeratorAssignCache from '../../DebaterAssign/ModeratorAssignCache';
import UserSelectField from '../UserSelectField/UserSelectField';
import SetupDropdown from '../../SetupDropdown/SetupDropdown';
import { storage, firestore, auth }  from "../../../firebase/firebase.js";
import { useAuth } from "../../../utils/AuthContext/authcontext";
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import avatar from './../../../assets/default-avatar.svg';
import { debateTypes } from '../debateFormatsDataV3';
import { useTranslation } from 'react-i18next';
import JoinDebateControls from './../JoinDebateControls/JoinDebateControls';

import {
  HiMicrophone,
  HiCalendar,
  HiCursorArrowRipple,
  HiMagnifyingGlass,
  HiClock,
  HiPlay,
  HiUser,
  HiUserGroup,
  HiChevronLeft,
  HiChevronRight,
  HiMiniCurrencyDollar,
  HiArrowPathRoundedSquare,
  HiCog6Tooth
} from 'react-icons/hi2';
import styles from './ArenaListView.module.css';
import Button from '../../ui/Button';
import { get } from 'idb-keyval';

const PAGE_SIZE = 5;

var unsubscribee = null; 

const ArenaListView = ({currentUser, OnComplete}) => {
  const { t } = useTranslation();
  const [arenas, setArenas] = useState([]);
  const [arenasclean, setArenasClean] = useState([]);
  const [filter, setFilter] = useState('all');
  const [mefilter, setMeFilter] = useState('');
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(0);
  const [pagemeta, setPageMeta] = useState([null]);
  const [pagerecv, setPageRecv] = useState(0);
  const [cursor, setCursor] = useState(null);
  const [getVisibility, setVisibility] = useState([]);
  //const [prevcursor, setprevCursor] = useState(null);
  const [hasMore, setHasMore] = useState(true);
  const [dateRange, setDateRange] = useState([null, null]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const [startDate, endDate] = dateRange;
  const {userData: currentUserData, searchbyUsersId } = useAuth();
  const [expanded, setExpanded] = useState([]);
  const [setupexpanded, setSetupexpanded] = useState([]);
  const { notify } = useNotifications();
  const [searchTarget, setSearchTarget] = useState(null);
  const [searchTargetTeam, setSearchTargetTeam] = useState(null);
  const [cachedResults, setCachedResults] = useState({});
  const [errors, setErrors] = useState({});
  const [arenaroles, setArenaroles] = useState([]);


  const [open, setOpen] = useState(true);
  
  const [wizardData, setWizardData] = useState({
    topic: '',
	description: '',
    formatId: null,
	schedule: { date: '', time: '' },
    custom: { rounds: null, participants: null, duration: null, time: 0, wage: 0, visibility: 'public', teams: [], teamsnumber: [] },
    roles: { debaters: [], moderator: null },
  });
 
  const updateplayers = async (arena, roles) => {
    await updateDoc(doc(firestore, 'arenas', arena.id), {
      roles: roles,
    });
  };
  
  /*useEffect(() => {
		const q = query(collection(firestore, "arenas"), orderBy('createdAt', 'desc'), ...(prevcursor ? [startAfter(prevcursor)] : []), limit(PAGE_SIZE));

		const unsubscribe = onSnapshot(q, (snapshot) => {
		 // loadPage(prevcursor, false);
		 console.log("change");
		});

		return () => unsubscribe();
  }, []);*/
  
 

	const loadPage = async (c = null, reset = false, page = undefined) => {
		if(c == null && page == undefined) setLoading(true);
		
		if(page != undefined) {
			c  = pagemeta[page];
		}
		
		if(unsubscribee != null) unsubscribee();
		const q = query(collection(firestore, 'arenas'), orderBy('createdAt', 'desc'), ...(c ? [startAfter(c)] : []), limit(PAGE_SIZE));
		
		unsubscribee = onSnapshot(q, (snapshot) => {
		  const updated = [];

		  snapshot.docChanges().forEach((change) => {
			const docData = { id: change.doc.id, ...change.doc.data(), createdAt: change.doc.data().createdAt.toDate(), pageid: pagerecv };
			if (change.type === "added") {
			  updated.push(docData);
			}
			if (change.type === "modified") {
			  setArenas((prev) =>
				prev.map((a) => (a.id === docData.id ? { ...a, ...docData } : a))
			  );
			}
			if (change.type === "removed") {
			  setArenas((prev) => prev.filter((a) => a.id !== docData.id));
			}
		  });

		  // Merge new adds with existing, sorted
		  setArenas((prev) => {
			const merged = [...updated, ...prev.filter((a) => !updated.find((u) => u.id === a.id))];
			return merged.sort((a, b) => (b.createdAt ?? 0) - (a.createdAt ?? 0));
		  });

		  if (snapshot.docs.length > 0 && page == undefined) {
			//setprevCursor(cursor);
			//setCursor(snapshot.docs[snapshot.docs.length - 1] || null);
			
			setPageMeta(prev => ({ ...prev, [pagerecv + 1]: snapshot.docs[snapshot.docs.length - 1] || null}));
			setHasMore(snapshot.docs.length === PAGE_SIZE);
		  }
		});
		/*const snap = await getDocs(q);
		const docs = snap.docs.map(d => ({
		id: d.id,
		...d.data(),
		createdAt: d.data().createdAt.toDate()
		}));
		setArenas(prev => (reset ? docs : [...prev, ...docs]));
		
		setprevCursor(cursor);
		setCursor(snap.docs[snap.docs.length - 1] || null);
		
		setHasMore(snap.docs.length === PAGE_SIZE);*/
	};

	const getNormalized = (arena, normalizedDebaters) => {
		return { debaters: normalizedDebaters ? normalizedDebaters : arena.roles.debaters, moderator: arena.roles.moderator };
	}
	

  //const onChange = (updateFn) => setWizardData(prev => ({ ...prev, ...updateFn(prev) }));
	const onChange = (arenaid, updateFn) => {
		var res = updateFn(arenaroles[arenaid]);
		setArenaroles(prev => ({ ...prev, [arenaid]: res}));
	};
	

	const removeEmpty = (obj) => {
	  let newObj = {};
	  Object.keys(obj).forEach((key) => {
		if (obj[key] === Object(obj[key])) newObj[key] = removeEmpty(obj[key]);
		else if (obj[key] !== undefined) newObj[key] = obj[key];
	  });
	  return newObj;
	};

	const onSaveArena = (arena) => {
		var newrolesm = null;
		const newrolesd = arenaroles[arena.id].debaters.filter((debaters, i) => {
			
			if(debaters == null) return false;
			return true;
		});
	
		const newrolesdf = newrolesd.map((debaters, i) => {
			const you = { uid: debaters?.uid, username: debaters?.username, email: debaters?.email, profilePicture: debaters?.profilePicture, team: debaters?.team, inviteToken: debaters?.inviteToken, role: debaters?.role};
			return removeEmpty(you);
		});
	
		if(arenaroles[arena.id].moderator != null) {
			newrolesm = { uid: arenaroles[arena.id].moderator?.uid, username: arenaroles[arena.id].moderator?.username, email: arenaroles[arena.id].moderator?.email, profilePicture: arenaroles[arena.id].moderator?.profilePicture, team: arenaroles[arena.id].moderator?.team, inviteToken: arenaroles[arena.id].moderator?.inviteToken, role: arenaroles[arena.id].moderator?.role};
			newrolesm = removeEmpty(newrolesm);
		}

		const newroles = {debaters: newrolesdf, moderator: newrolesm}
		updateplayers(arena, newroles); 
	};

	useEffect(() => {
		//console.log(wizardData.roles);
	}, [wizardData]);

	// Prevent duplicates on manual user selection
	const handleUserSelect = (type, user, i, teamName, arena, normalizedDebaters) => {
		onChange(arena.id, prev => {
			const { debaters = [], moderator } = prev || getNormalized(arena, normalizedDebaters);

			// Extract all identifiers already used
			const usedUIDs = debaters.map(d => d?.uid).concat(moderator?.uid);
			const usedEmails = debaters.map(d => d?.email).concat(moderator?.email);

			const isDuplicate = user?.uid ? usedUIDs.includes(user.uid) : user?.email && usedEmails.includes(user?.email);

			if (isDuplicate) return prev || getNormalized(arena, normalizedDebaters); // skip if already selected
			
			var newroles = prev || getNormalized(arena, normalizedDebaters);
			const updated = { ...newroles};
			
			if(searchTarget != null) {
				if (searchTarget === 'mod') {
				const you = { uid: user.uid, username: user.username, email: user.email, profilePicture: user.profilePicture};
				updated.moderator = you;
				} else {
				const newDebaters = [...debaters];
				const you = { uid: user.uid, username: user.username, email: user.email, team: searchTargetTeam, profilePicture: user.profilePicture};
				newDebaters[searchTarget] = you;
				updated.debaters = newDebaters;
				}
			}else {
				if(type) {
					updated.moderator = user;
				} else {
				const newDebaters = [...debaters];
				if(user != null && teamName != undefined) {
					user['team'] = teamName;
					newDebaters[i] = user;
				}
				else {
					newDebaters[i] = user;
				}
				updated.debaters = newDebaters;
				}
			}
			return updated;
		});
		setErrors({});
		setSearchTarget(null);
		setSearchTargetTeam(null);
		};

	const loadPageSync = (c = null, reset = false) => {
		setLoading(true);
		const q = query(collection(firestore, 'arenas'), orderBy('createdAt', 'desc'), ...(c ? [startAfter(c)] : []), limit(PAGE_SIZE));
		onSnapshot(q, snap => {
		const docs = snap.docs.map(d => ({
			id: d.id,
			...d.data(),
			createdAt: d.data().createdAt.toDate()
		}));
		setArenas(prev => (reset ? docs : [...prev, ...docs]));
		setCursor(snap.docs[snap.docs.length - 1] || null);
		setHasMore(snap.docs.length === PAGE_SIZE);
		});
	};

	useEffect(() => {
		if(arenas?.length > 0) {
		const fetchUserData = async () => {
			let data = await Promise.all(arenas.map(async (arena) => {
				var update = false;
				if(arena?.createdBy != undefined) {
					const users = await searchbyUsersId(arena.createdBy);
					arena.createdUserBy = users[0];
				}
				if(arena?.roles.debaters.length > 0) {
					let debt = await Promise.all(arena?.roles.debaters.map(async (debater) => {
						if(debater?.uid != undefined) {
							const users = await searchbyUsersId(debater?.uid);
							var team = debater.team;
							debater = users[0];
							debater.team = team;
						}
						return debater;
					}))
					update = true;
					arena.roles.debaters = debt;
				}
				else 
				{
					update = true;
					arena.roles.debaters = [];
				}
				if(arena?.roles.moderator != null && arena?.roles.moderator?.uid != undefined) {
					const users = await searchbyUsersId(arena?.roles.moderator?.uid);
					update = true;
					arena.roles.moderator = users[0];
				}

				if(getVisibility[arena.id] === undefined) {
					setVisibility(prev => ({...prev, [arena.id]: arena.custom?.visibility === 'public'}));
				}

				if(update == true) {
					return arena;
				}
				return null;
			}))
			

			data = data.filter(function(item) {
				return item !== null
			})
			
			//console.log(data)
			if(data) setArenasClean(data)
			setLoading(false);
			setTimeout(() => {
				if(OnComplete)OnComplete();
			}, 1000);
			
		};

		fetchUserData();
		} else {
			setLoading(false);
			setTimeout(() => {
				if(OnComplete)OnComplete();
			}, 1000);
		}
	}, [arenas]);
	
	useEffect(() => {
		setPageRecv(0);
		//loadPage(null, true);
	}, []);

	useEffect(() => {
		if(pagerecv > 0) {
			loadPage(null, false, page);
		}
	}, [page]);

	useEffect(() => {
		if(pagerecv == 0) {
			loadPage(null, true);
		} else {
			if (hasMore) {
			//console.log("load at ", pagerecv)
			loadPage(pagemeta[pagerecv]);
			}
		}
	}, [pagerecv]);

	const filtered = arenasclean.filter(a => {
		const meta = debateTypes.find(m => m.id === a.formatId?.toLowerCase()) || {};

		const ispublic = a.custom?.visibility === 'public' || a.custom?.visibility == undefined;

		if(!ispublic) {
			const isUserPresent = a?.roles.debaters?.find(s => s.uid === currentUser.uid) || currentUser.uid === a.createdUserBy.uid || false;	
			var isUserModPresent = false;
			if(a?.roles.moderator != null && a?.roles.moderator?.uid != undefined && a?.roles.moderator?.uid === currentUser.uid) {
				isUserModPresent = true;
			}
			if(isUserPresent == false && isUserModPresent == false) return false;
		}

		const readyWindowHours = Number(a.custom?.readywindow) || 24;
		const readyWindowMs = readyWindowHours * 60 * 60 * 1000;
		const sched = new Date(`${a.schedule.date}T${a.schedule.time}`);
		const now = new Date();

		function getDebateStatus() {
			var debateStatus = a?.engineState?.state?.status;
			if (debateStatus === 'active') return 'live';
			if (sched > now) return 'scheduled';

			const sinceSched = now.getTime() - sched.getTime();
			if (sinceSched <= readyWindowMs && debateStatus !== 'ended') return 'ready';
			return 'archived';
		}

		if(mefilter === 'me') {
			const isUserPresent = a?.roles.debaters?.find(s => s.uid === currentUser.uid) || currentUser.uid === a.createdUserBy.uid || false;
			var isUserModPresent = false;
			if(a?.roles.moderator != null && a?.roles.moderator?.uid != undefined && a?.roles.moderator?.uid === currentUser.uid) {
				isUserModPresent = true;
			}

			if(isUserPresent == false && isUserModPresent == false) return false;
		}

		
		if(a?.roles.debaters.length <= 0) return false;
		if (filter === 'live' && getDebateStatus() !== 'live') return false;
		if (filter === 'future' && getDebateStatus() !== 'scheduled') return false;
		if (filter === 'ready' && getDebateStatus() !== 'ready') return false;
		if (startDate && !endDate) {
		const sched = new Date(`${a.schedule.date}T${a.schedule.time}`);
		if (sched <= new Date()) return false;
		}
		if (startDate && endDate) {
		const sched = new Date(`${a.schedule.date}T${a.schedule.time}`);
		if (sched < startDate || sched > endDate) return false;
		}

		const lc = search.toLowerCase();
		if (search && !a.title.toLowerCase().includes(lc) && !a.topic?.text.toLowerCase().includes(lc) && !meta?.title.toLowerCase().includes(lc)) return false;

		return true;
	});

	const totalPages = Math.ceil(filtered.length / PAGE_SIZE);  
	const paginated = filtered.slice(page * PAGE_SIZE, (page + 1) * PAGE_SIZE);
	const handleLoadMore = () => {
		if (hasMore) {
		setPageRecv(pagerecv + 1);
		//loadPage(cursor);
		//setPage(prev => prev + 1);
		}
	};

	const handleSetup = (e, arena) => {
		if(setupexpanded[arena.id] !== true)
		{
			setSetupexpanded(prev => ({[arena.id]: !setupexpanded[arena.id]}));
		}
		e.stopPropagation();
		return true;
	}

	const handleJumpTo = idx => {
		if (idx < 0 || idx >= totalPages) return;
		setPage(idx);
		if (idx > 0 && arenas.length < (idx + 1) * PAGE_SIZE) {
			if (hasMore) {
			setPageRecv(pagerecv + 1);
			}
		}
		window.scrollTo({ top: 0, behavior: 'smooth' });
	};
  
	const handleJoin = async (role, teamIdx, arenaId) => {
	  const arenaRef = doc(firestore, 'arenas', arenaId);
	  var arenaSnap = await getDoc(arenaRef);
	  var arenaData = arenaSnap.data();


	  //console.log('Joining arena with role:', role, 'teamIdx:', teamIdx, 'arenaId:', arenaId);
	  if (!arenaData) return;

	  const userData = {
		uid: currentUser.uid,
		email: currentUser.email,
		username: currentUserData.username || '',
		profilePicture: currentUserData.profilePicture || '',
	  };

	  if (role === 'debater') {
		const debaters = [...(arenaData.roles?.debaters || [])];
		const start = arenaData.custom.teamsnumber
		  .slice(0, teamIdx)
		  .reduce((sum, n) => sum + n, 0);
		const slots = arenaData.custom.teamsnumber[teamIdx];

		for (let i = start; i < start + slots; i++) {
		  if (!debaters[i]?.uid) {
			debaters[i] = {
			  ...debaters[i],
			  ...userData,
			  team: arenaData.custom.teams[teamIdx],
			};
			await updateDoc(arenaRef, {'roles.debaters': debaters,});
			arenaData = {
			  ...arenaData,
			  id: arenaId,
			  roles: {
				...arenaData.roles,
				debaters,
			  },
			};
			handleNavigate(arenaData);
			return;
		  }
		}
	  }

	  if (role === 'moderator') {
		const moderator = {
		  ...arenaData.roles?.moderator,
		  ...userData,
		};
		await updateDoc(arenaRef, {'roles.moderator': moderator,});
		arenaData = {
		  ...arenaData,
		  id: arenaId,
		  roles: {
			...arenaData.roles,
			moderator,
		  },
		};
		handleNavigate(arenaData);
		return
	  }

	  if (role === 'spectator') {
		const existing = arenaData.spectators || [];
		const alreadySpectator = existing.find(s => s.uid === currentUser.uid);
		if (!alreadySpectator && existing.length < 100) {
		  await updateDoc(arenaRef, {spectators: arrayUnion(userData),});
			arenaData = {
			  ...arenaData,
			  id: arenaId,
			  spectators: (() => {
				const existing = arenaData?.spectators || [];

				// prevent duplicates (arrayUnion behavior)
				const alreadyExists = existing.some(
				  (u) => u.uid === userData.uid
				);

				return alreadyExists
				  ? existing
				  : [...existing, userData];
			  })(),
			};
		  handleNavigate(arenaData);
		  return
		}
	  }
	};

	const handlePrivacyChange = async (arenaId, isPublic) => {
		const arenaRef = doc(firestore, 'arenas', arenaId);
		await updateDoc(arenaRef, {
			'custom.visibility': isPublic ? 'public' : 'private'
		});
	};

	const getDebateStatus = (anarena) => {
		var debateStatus = anarena?.engineState?.state?.status;
		const readyWindowHours = Number(anarena.custom?.readywindow) || 24;
		const readyWindowMs = readyWindowHours * 60 * 60 * 1000;
		const now = new Date();
		const sched = new Date(`${anarena.schedule.date}T${anarena.schedule.time}`);
		if (debateStatus === 'active') return 'live';
		if (sched > now) return 'scheduled';

		const sinceSched = now.getTime() - sched.getTime();
		if (sinceSched <= readyWindowMs && debateStatus !== 'ended') return 'ready';
		return 'archived';
	}

	const handleNavigate = (arena) => {
		const meta = debateTypes.find(m => m.id === arena.formatId?.toLowerCase()) || {};
		const isModerator = arena?.roles?.moderator?.uid === currentUser?.uid;
		const isDebater = arena?.roles?.debaters?.some(d => d?.uid === currentUser.uid);
		const isSpectator = arena?.spectators?.find(s => s.uid === currentUser.uid) || false;
		const NoSpectators = arena?.spectators?.length || 0;
		if(arena != undefined && (!isDebater && !isModerator && !isSpectator)) 
		{
			notify('info', 'You dont have a role in this debate. Please join as a spectator to watch or ask the host to assign you a role.');
			return;
		}
		const allFilled = arena.roles.debaters.every(u => u?.uid !== undefined);
		const ModeratorFilled = true;//arena.roles?.moderator == null ? true : arena.roles?.moderator?.uid !== undefined;
		if(allFilled && ModeratorFilled) {
			navigate(`/debates/${arena.id}`);
			return;
		}

		if(allFilled == false) {
			notify('info', 'Some debaters are not ready yet.');
		} else if(allFilled && ModeratorFilled == false) {
			notify('info', 'A moderator has not signed up yet.');
		}
		return;
	};

  return (
    <div className={styles.container}>
      {arenas?.length > 0  ? <div className={styles.controls}>
        <div className={styles.searchWrap}>
          <HiMagnifyingGlass className={styles.searchIcon} />
          <input
            type="text"
            placeholder="Search by title or topic or debate type..."
            value={search}
            onChange={e => setSearch(e.target.value)}
            className={styles.search}
          />
        </div>
        <DatePicker
          selectsRange
          startDate={startDate}
          endDate={endDate}
          onChange={setDateRange}
          isClearable
          placeholderText="Filter by date range"
          className={styles.search}
        />
        <div className={styles.filters}>
          <Button
            variant={mefilter === 'me' ? 'primary' : 'ghost'}
            className={`${styles.filterBtn} ${mefilter === 'me' ? styles.active : ''}`}
            onClick={() => {mefilter === 'me' ?  setMeFilter('') : setMeFilter('me')}}
          >
            <HiUser /> Me
          </Button>
          <Button
            variant={filter === 'all' ? 'primary' : 'ghost'}
            className={`${styles.filterBtn} ${filter === 'all' ? styles.active : ''}`}
            onClick={() => setFilter('all')}
          >
            <HiUserGroup /> All
          </Button>
          <Button
            variant={filter === 'live' ? 'primary' : 'ghost'}
            className={`${styles.filterBtn} ${filter === 'live' ? styles.active : ''}`}
            onClick={() => setFilter('live')}
          >
            <HiPlay /> Live
          </Button>
		  <Button
            variant={filter === 'ready' ? 'primary' : 'ghost'}
            className={`${styles.filterBtn} ${filter === 'ready' ? styles.active : ''}`}
            onClick={() => setFilter('ready')}
          >
            <HiPlay /> Ready
          </Button>
          <Button
            variant={filter === 'future' ? 'primary' : 'ghost'}
            className={`${styles.filterBtn} ${filter === 'future' ? styles.active : ''}`}
            onClick={() => setFilter('future')}
          >
            <HiClock /> Upcoming
          </Button>
        </div>
      </div> : <> </>}

      <div className={styles.list}>
        {loading
          ? Array.from({ length: PAGE_SIZE }).map((_, i) => <div key={i} className={styles.cardSkeleton} />
		  
		  ) : paginated.length === 0 ? (
			  <div className={styles.noData}>
				<p>No arenas found with current filters.</p>
			  </div>
		  ): paginated.map((arena, i) => (
              <div  key={arena.id} className={styles.setuplayout}>
			  <motion.div
                key={arena.id}
                className={styles.card}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: i * 0.05 }}
                onClick={() => handleNavigate(arena)}>
				
                <div className={styles.creatoravatar}>
				  <h2>Host: {arena.createdUserBy.username}</h2>
                  <img src={arena.createdUserBy.profilePicture || avatar} alt="Creator avatar" title={`${arena.createdUserBy.username || 'Debater'}`}/>
					{(() => {
					  const meta = debateTypes.find(m => m.id === arena.formatId?.toLowerCase()) || {};
					  return (
						<div className={styles.formattags}>
						  <span className={styles.scheduled}>{meta.title}</span>
						</div>
					  );
					})()} 
                </div>
				<div className={`${styles.formatsetup} ${arena.createdUserBy.uid === currentUser.uid && (getDebateStatus(arena) === 'ready' || getDebateStatus(arena) === 'scheduled') ? '' : styles.setuphidden}`}  onClick={(e) => {e.stopPropagation(); handleSetup(e, arena);}}>
					<HiCog6Tooth size={20}/>
				</div>
                <div key={`${arena.id}${i}`} className={styles.content}>
					<div className={styles.versusBlock}>
					  <div className={styles.stackLeft}>
						{arena.roles.debaters.filter(sdebate => (sdebate.team || arena.custom.teams[0]) === arena.custom.teams[0])
						  .map((debater, j) => (
							<img
							  key={`${debater.uid}${j}`} src={debater.profilePicture || avatar}
							  alt="Pro Debater"
							  title={`${debater.username || 'Debater'} (${debater.team})`}
							  className={`${styles.debaterAvatar} ${styles.pro}`}
							/>
						  ))}
					  </div>
					  {arena.custom.teams.length >= 2 && <><div className={styles.vsText}>VS</div>
					  <div className={styles.stackRight}>
						{arena.roles.debaters.filter(sdebate => (sdebate.team || arena.custom.teams[1]) === arena.custom.teams[1])
						  .map((debater, j) => (
							<img
							   key={`${debater.uid}${j}`} src={debater.profilePicture || avatar}
							  alt="Con Debater"
							  title={`${debater.username || 'Debater'} (${debater.team})`}
							  className={`${styles.debaterAvatar} ${styles.con}`}
							/>
						  ))}
					  </div></>}
					</div>
					{arena.roles?.moderator != undefined ? <div className={styles.modertoravatar}>
					   <h2>Moderator: {arena.roles?.moderator.username}</h2>
					  <img src={arena.roles?.moderator.profilePicture || avatar} alt="Creator avatar" title={`${arena.roles?.moderator.username || 'Debater'}`}/>
					</div> : <></>}
                  <h2>{arena.title}</h2>

					<div className={styles.description}>
					  <p>
						{expanded[arena.id] || !(arena.description && arena.description.length > 100)
						  ? arena?.description : `${arena.description?.slice(0, 100)}... `}
					  </p>
					  {arena.description && arena.description.length > 100 && (
						<Button variant="secondary" className={styles.seeMoreBtn}
						  onClick={(e) => {
							e.stopPropagation(); // prevent card click
							setExpanded(prev => ({...prev, [arena.id]: !expanded[arena.id]}));
						  }}
						>
						  {expanded[arena.id] ? 'See less' : 'See more'}
						</Button>
					  )}
					</div>
                  <div className={styles.meta}>
                    <span><HiMicrophone /> Rounds: {arena.custom?.rounds || 1}</span>
					{(() => {
					  const meta = debateTypes.find(m => m.id === arena.formatId?.toLowerCase()) || {};
					  const totaldebateSec = arena?.custom?.rounds * (meta?.turns || []).reduce((acc, turn) => acc + (turn?.durationSec || 0), 0);
					  return (
						    <span><HiCursorArrowRipple /> Estimated Runtime: {Math.ceil(totaldebateSec / 60)} minutes</span>
					  );
					})()}

                    <span><HiCalendar /> {arena.schedule.date} - {arena.schedule.time}</span>
					{arena.custom?.wager > 0 ? <span><HiMiniCurrencyDollar/>Wager: ${arena.custom?.wager || 0}</span>: <></>}
                  </div>
                  <div className={styles.tags}>
					{(() => {
						const now = new Date();
						const sched = new Date(`${arena.schedule.date}T${arena.schedule.time}`);
						const maxAllowed = arena.custom?.participants;
						const pendinginvite = arena.roles.debaters.every(u => u?.uid !== undefined);
						const allFilledcount = arena.roles.debaters.filter(u => u?.uid !== undefined);
						const NoSpectators = arena?.spectators?.length || 0;
						const readyWindowHours = Number(arena.custom?.readywindow) || 24;
						const readyWindowMs = readyWindowHours * 60 * 60 * 1000;

						function getDebateStatus() {
							var debateStatus = arena?.engineState?.state?.status;
							if (debateStatus === 'active') return 'live';
							if (sched > now) return 'scheduled';

							const sinceSched = now.getTime() - sched.getTime();
							if (sinceSched <= readyWindowMs && debateStatus !== 'ended') return 'ready';
							return 'archived';
						}


					  const isUserInArena = arena.roles.debaters.some(u => u?.uid === currentUser.uid) || arena.roles.moderator?.uid === currentUser.uid;
					  const isToday = sched.toDateString() === now.toDateString();
					  const meta = debateTypes.find(m => m.id === arena.formatId?.toLowerCase()) || {};
					  return (
						<div className={styles.tags}>
						  {getDebateStatus() === 'live' && <span className={styles.live}>{t('ui.live')}</span>}
						  {getDebateStatus() === 'scheduled' && <span className={styles.scheduled}>{t('ui.scheduled')}</span>}
						  {getDebateStatus() === 'ready' && <span className={styles.ready}>{t('ui.ready')}</span>}
						  {getDebateStatus() === 'archived' && <span className={styles.archived}>{t('ui.archived')}</span>}
						  {!pendinginvite && <span className={styles.full}>{t('ui.pendingInvitations')}</span>}
						  {allFilledcount.length >= maxAllowed && <span className={styles.full}>{t('ui.full')}</span>}

						  {arena.custom?.wager > 0 && (
							<span className={styles.wagered}>{t('ui.wagered')}</span>
						  )}
						  {isUserInArena && <span className={styles.mine}>{t('ui.participating')}</span>}
						  {isToday && !arena.roundActive && <span className={styles.today}>{t('ui.today')}</span>}
						  {<span className={styles.today}>MAX. PARTICIPANTS: {maxAllowed}</span>}
						  {meta?.spectators?.canParticipate && NoSpectators < 100 && <span className={styles.noSpectators}>{t('ui.Spectatorsallowed')}</span>}
						</div>
					  );
					})()}                    
					<span>{arena.custom?.visibility.toUpperCase()}</span>
                  </div>
				  <div>
					{!arena.roles.debaters.some(d => d?.uid === currentUser?.uid) && arena.roles.moderator?.uid !== currentUser?.uid && currentUser && (
						<JoinDebateControls user={currentUser} arena={arena} onJoin={handleJoin} />
					)}
				  </div>
                </div>
              </motion.div>


			  <SetupDropdown className={styles.setupview} isOpen={setupexpanded[arena.id] == true}  onClose={() => {setSetupexpanded(prev => ({[arena.id]: false}));}}
				onConfirm={(activeTab) => {
				  loadPage(null, false, arena?.pageid);
				  if(activeTab === "roles") {
					onSaveArena(arena);
				  } else if(activeTab === "privacy") {
					handlePrivacyChange(arena.id, getVisibility[arena.id]);
				  } else if(activeTab === "notifications") {
					// Notification settings would be handled here if implemented
				  }
				  setSetupexpanded(prev => ({[arena.id]: false}));
				}}
				tabs={[{
					  id: "roles",
					  label: "Edit Roles",
					  content: (
							<div className={`${setupexpanded[arena.id] == true ? styles.setupshow : styles.setuphidden}`}>
								{(() => {
								  const now = new Date();
								  const sched = new Date(`${arena.schedule.date}T${arena.schedule.time}`);
								  const maxAllowed = arena.custom?.participants;
								  const pendinginvite = arena.roles.debaters.every(u => u?.uid !== undefined);
								  const allFilledcount = arena.roles.debaters.filter(u => u?.uid !== undefined);
								   
								  const isUserInArena = arena.roles.debaters.some(u => u?.uid === currentUser.uid) || arena.roles.moderator?.uid === currentUser.uid;
								  const isToday = sched.toDateString() === now.toDateString();
								  const meta = debateTypes.find(m => m.id === arena.formatId?.toLowerCase()) || {};
								  var isModeratorValid = meta?.roles?.judge?.exists === true || meta?.roles?.moderator?.exists === true || false; 
								  const newroles = arenaroles[arena.id] || arena.roles

								  	//console.log(newroles)
								  return (
									<>
									{/*<h2>Assign Roles</h2>*/}
									{errors.debaters && <p className={styles.error}>{errors.debaters}</p>}
									{errors.moderator && <p className={styles.error}>{errors.moderator}</p>}

									<DebaterAssignCache
										  arena={arena} 
										  custom={arena.custom}                     // team and participant config
										  roles={newroles}                       // current debater UID assignments
										  currentUser={currentUser}           // current logged-in user object
										  cache={cachedResults}
										  resetSlots={arena.custom.initialized}
										  setCache={setCachedResults}
										  handleUserSelect={handleUserSelect} // selection logic for adding user
										  setSearchTarget={setSearchTarget}   // optional UI logic for modal/selector
										  setSearchTargetTeam={setSearchTargetTeam}/>

										{isModeratorValid && (
											<ModeratorAssignCache
											  arena={arena}
											  custom={arena.custom}                     // team and participant config
											  roles={newroles}                       // current debater UID assignments
											  currentUser={currentUser}           // current logged-in user object
											  cache={cachedResults}
											  resetSlots={arena.custom.initialized}
											  setCache={setCachedResults}
											  handleUserSelect={handleUserSelect} // selection logic for adding user
											  setSearchTarget={setSearchTarget}   // optional UI logic for modal/selector
											  setSearchTargetTeam={setSearchTargetTeam}/>
										)}
									</>
								  );
								})()}
							</div>					  
						),
					},
					{
					  id: "privacy",
					  label: "Privacy",
					  content: (
						<div className={styles.privacySettings}>
						  <label> {t('ui.arenavisibility')}: </label> <input type="checkbox"  checked={getVisibility[arena.id]} onChange={e => setVisibility(prev => ({...prev, [arena.id]: e.target.checked})) }/><label>{arena.custom?.visibility?.toUpperCase()}</label>
						</div>
					  ),
					},
					{
					  id: "notifications",
					  label: "Notifications",
					  content: (
						<div>
						  {t('ui.notificationSettingsComingSoon')}
						</div>
					  ),
					},
				]}
				defaultTabId="roles"
				title="User Settings"/>
		

			  </div>
            ))}
      </div>

      <div className={styles.pagination}>
        <Button onClick={() => handleJumpTo(page - 1)} disabled={page === 0}><HiChevronLeft /></Button>
        <div className={styles.pageJump}>
          Page <input
            type="number"
            min="1"
            max={totalPages}
            value={page + 1}
            onChange={e => handleJumpTo(Number(e.target.value) - 1)}
            className={styles.jumpInput}
          /> of {totalPages}
        </div>
        <Button onClick={() => handleJumpTo(page + 1)} disabled={page + 1 >= totalPages}><HiChevronRight /></Button>
        {hasMore && <Button onClick={handleLoadMore} className={styles.loadMore}><HiArrowPathRoundedSquare /> Load More</Button>}
      </div>
    </div>
  );
};

export default ArenaListView;
